import React from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { ContactSection } from "@/components/sections/ContactSection";

export default function ContactPage() {
  return (
    <main>
      <PageHeader eyebrow="Contact" title="We’d love to hear from you." lead="Media, partnerships or general enquiries — reach us via the form or the details below." />
      <ContactSection />
    </main>
  );
}
